import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { testimonials } from "../data/siteData";
import { Badge } from "../Components/ui/Badge";

export default function TestimonialsSection() {
  return (
    <section id="testimonials" className="border-t border-zinc-200 bg-brand-surface py-24">
      <div className="mx-auto max-w-7xl px-6">
        <h2 className="mb-16 text-center font-display text-4xl font-bold text-brand-ink md:text-5xl">
          What our partners say
        </h2>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((test, i) => (
            <motion.div
              key={test.name}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="group relative flex flex-col overflow-hidden rounded-3xl border border-zinc-200 bg-white p-8 transition-all hover:border-brand-purple/30 hover:shadow-lg"
            >
              <Quote className="absolute -right-4 -top-4 h-24 w-24 rotate-12 text-brand-purple/5" />
              <div className="relative z-10 mb-6 flex gap-1 text-brand-purple">
                {[1, 2, 3, 4, 5].map((s) => (
                  <Star key={s} size={16} fill="currentColor" />
                ))}
              </div>
              <p className="relative z-10 mb-8 flex-1 text-lg font-medium leading-relaxed text-brand-ink">
                &ldquo;{test.quote}&rdquo;
              </p>
              <div className="relative z-10 mt-auto flex items-center gap-4">
                <img
                  src={test.img}
                  alt={test.name}
                  className="h-12 w-12 rounded-full border border-zinc-200 object-cover object-top shadow-sm"
                />
                <div>
                  <h4 className="flex flex-wrap items-center gap-2 font-display text-sm font-bold text-brand-ink">
                    {test.linkedinUrl ? (
                      <a
                        href={test.linkedinUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="transition-colors hover:text-brand-purple"
                      >
                        {test.name}
                      </a>
                    ) : (
                      test.name
                    )}
                    {test.verified && (
                      <Badge className="h-4 border border-blue-100 bg-blue-50 px-1.5 py-0 text-[10px] text-blue-600 hover:bg-blue-100">
                        Verified
                      </Badge>
                    )}
                  </h4>
                  <p className="text-xs text-brand-muted">
                    {test.companyUrl ? (
                      <a
                        href={test.companyUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="transition-colors hover:text-brand-purple"
                      >
                        {test.role}
                      </a>
                    ) : (
                      test.role
                    )}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
